import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Skeleton from "@mui/material/Skeleton";
import FormControlLabel from "@mui/material/FormControlLabel";

interface Props {
	label: string;
	value: number;
	onChange: (
		event: React.ChangeEvent<HTMLInputElement>,
		checked: boolean,
	) => void;
}

const SwitchField = ({ label, value, onChange }: Props) => {
	return (
		<Box sx={{ mt: 2, mb: 2, height: "41px" }}>
			<FormControlLabel
				sx={{ m: 0 }}
				control={
					<Switch type='checkbox' name='subscribe-sms' onChange={onChange} />
				}
				label={label}
				value={value === 1}
				checked={value === 1}
				componentsProps={{ typography: { variant: "body2" } }}
			/>
		</Box>
	);
};

export default SwitchField;
